<template>
  <section class="card mgt-20px">
    <header class="header-card">
      <p> {{ $t('addEditFournisseurs.infoComptable.title')}} </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('addEditFournisseurs.infoComptable.compteComptable')">
            <b-input v-model="fournisseur.compteComptable"></b-input>
          </b-field>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InfoComptableFournisseurs',
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
  },
};
</script>
